import { Injectable, Type } from '@angular/core';
import { Mapper } from '@dynamic-mapper/angular';
import { MappingPair } from '@dynamic-mapper/mapper';
import { ThemeService } from '../../theme/theme.service';

@Injectable({
  providedIn: 'root'
})
export class CommonHelperService {

  constructor(
    private readonly mapper: Mapper, private themeservice: ThemeService
  ) { }

  //Generic Array Mapper Method
  genericArrayMapper<I,O>(data: I[], mapProfile: MappingPair<I,O>): O[] {
    const mappingProfile: MappingPair<I,O> =  mapProfile;
    let arrayData: O[]= [];
    if (data && data.length > 0) {
      data.forEach((d: I) => {
        arrayData.push(this.mapper.map(mappingProfile,d));
      });
    }
    return arrayData;
  }

  //Generic Mapper Method
  genericObjectMapper<I,O>(data: I, mapProfile: MappingPair<I,O>): O {

    const mappingProfile: MappingPair<I,O> =  mapProfile;
    let mappedData!: O;
    if (data) {
       mappedData = this.mapper.map(mappingProfile,data);
    }
    return mappedData;

  }


  isDarkEnabled(): boolean {
    const preference = localStorage.getItem("darkModePreference");
    const isDark = preference === 'true';
    this.themeservice.toggleDarkTheme(isDark);
    return isDark;
  }
  


}
